import React from 'react'
import { Toggle } from '../../legacy-design-system/toggle'
import { FormattedMessage } from 'react-intl'
import { CsHelpCircledIcon } from '../../legacy-design-system/icons'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { WithTooltip } from '../../design-system'
import { css } from '@emotion/css'
import { Label } from '../../legacy-design-system/form-label'
import { ContrastFormattedMessage } from '../contrast-formatted-message'

interface OssFeature {
  readonly oss: boolean
  readonly inventoryMode: boolean
}

export interface OssFeatureSwitchProps {
  readonly onUpdate?: (ossFeature: OssFeature) => void
  readonly oss?: boolean
  readonly inventoryMode?: boolean
  readonly ossLicense?: boolean
}

interface State {
  readonly enabled: boolean
  readonly requiresAssess: boolean
}

const containerCss = css`
  width: 100%;
  display: flex;
  align-items: center;
`

const toggleContainerCss = css`
  margin-top: 3px;
  margin-botton: 0px;
`

const helpIconContainerCss = css`
  display: inline-block;
  padding-left: 6px;
  padding-right: 6px;
`
const helpIconTooltipContainerCss = css`
  max-width: 250px;
`
export const ossFeatureSwitchCheckboxTestId = 'oss-feature-switch-checkbox'

export class OssFeatureSwitch extends React.Component<
  OssFeatureSwitchProps,
  State
> {
  public state: State = {
    enabled: this.props.oss || this.props.inventoryMode ? true : false,
    requiresAssess: this.props.oss ? this.props.oss : false
  }

  public render() {
    const helpMessage = () => {
      if (!this.props.ossLicense) {
        return (
          <FormattedMessage id="detail_addOrganizationModal_ossLicensingExpired" />
        )
      }
    }
    return (
      <span className={containerCss}>
        <ContrastFormattedMessage id="action_addOrganizationModal_ossLicensing">
          {(msg) => {
            return <Label>{msg}</Label>
          }}
        </ContrastFormattedMessage>
        <OssFeatureHelpIcon />
        <span className={toggleContainerCss}>
          <Toggle
            disabled={this.props.ossLicense ? false : true}
            checked={this.state.enabled}
            onChange={this.toggleOss}
          />
        </span>
        {helpMessage()}
      </span>
    )
  }

  private toggleOss = () => {
    const { enabled } = this.state
    this.onUpdate(!enabled, false)
    this.setState((prevState) => ({
      enabled: !prevState.enabled,
      requiresAssess: false
    }))
  }

  private onUpdate(enabled: boolean, requiresAssess: boolean) {
    const { onUpdate } = this.props
    if (onUpdate) {
      onUpdate({
        oss: requiresAssess,
        inventoryMode: enabled && !requiresAssess
      })
    }
  }
}

function OssFeatureHelpIcon() {
  return (
    <span className={helpIconContainerCss}>
      <WithTooltip
        children={() => (
          <CsHelpCircledIcon color={theme.color.neutral50} size={18} />
        )}
        placement="bottom"
        renderTooltipContent={() => (
          <div className={helpIconTooltipContainerCss}>
            <FormattedMessage id="detail_addOrganizationModal_ossLicensingProvideFullAssessOpenSourceLibraries" />
          </div>
        )}
      />
    </span>
  )
}
